export const NftItemTileType = {
    REGULAR_TILE: 'REGULAR_TILE',
    CREATOR_REGULAR: 'CREATOR_REGULAR',
    COLLECTOR_TILE: 'COLLECTOR_TILE',
    COLLECTOR_TILE_NO_CTA: 'COLLECTOR_TILE_NO_CTA',
    COLLECTOR_TILE_NO_CREATOR: 'COLLECTOR_TILE_NO_CREATOR',
} as const;
